import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { NEW_VERSION_EVENT } from "@dwelldrop/shared";

export default function NewVersionModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (): void => setOpen(true);
    window.addEventListener(NEW_VERSION_EVENT, handler);
    return () => window.removeEventListener(NEW_VERSION_EVENT, handler);
  }, []);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="new-version-title"
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-4"
    >
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 rounded-lg bg-blue-100">
              <RefreshCw className="h-6 w-6 text-blue-600" />
            </div>
            <h3 id="new-version-title" className="text-lg font-semibold text-blue-900">
              New version available
            </h3>
          </div>
          <p className="text-gray-700 leading-relaxed mb-6">
            A new version of the app has been deployed. Click OK to refresh and get the latest updates.
          </p>
          <div className="flex items-center justify-end">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
